import React from "react";
import styled from "styled-components";
import imgBanner from "./../assets/Hinh-banner-landing-page-2025.png";

const Header = () => {
	return (
		<Container>
			<img src={imgBanner} alt="Banner" />
		</Container>
	);
};

const Container = styled.div`
	width: 1170px;
	margin: 0 auto;
	img {
		height: auto;
	}
	@media only screen and (max-width: 767px) {
		width: 100%;
		img {
			width: 100%;
			height: auto;
			aspect-ratio: auto 1170 / 313;
		}
	}
`;

export default Header;
